<template>
  <v-dialog v-model="dialog" persistent width="550">
    <!--include form-->
    <change-password @dialog="dialog = false"/>
  </v-dialog>

  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      location="end"
    >
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" rounded width="8" height="45">
          <v-avatar size="36">
            <v-img
              alt="Avatar"
              :src="user.photo"
            ></v-img>
          </v-avatar>
        </v-btn>
      </template>

      <v-card min-width="250">
        <v-list>
          <v-list-item
            :prepend-avatar="user.photo"
            :title="user.fullname"
            :subtitle="user.job?.name">
            <template v-slot:append>
              <v-btn
                variant="text"
                :class="fav ? 'text-red' : ''"
                icon="mdi-heart"
                @click="fav = !fav"
              ></v-btn>
            </template>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item 
            title="Mon profil" 
            prepend-icon="mdi-clipboard-account-outline"
            @click.prevent="showProfile"
          ></v-list-item>
          <v-divider></v-divider>
          <v-list-item
            title="Mot de passe"
            prepend-icon="mdi-lock-outline"
            @click.prevent="changePassword"
          >
          </v-list-item>
          <v-list-item 
            title="Préférences"
            prepend-icon="mdi-cog-box"
            @click.prevent="openConfig"
            v-if="user.is_superuser"
          ></v-list-item>
          <v-divider></v-divider>
          <v-list-item
            title="Déconnecter"
            prepend-icon="mdi-logout"
            @click="$store.dispatch('logout')"
          ></v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from "@/router";
import ChangePassword from "@/components/account/ChangePassword.vue"

export default {
  name: 'MenuPopover',
  components: {
    ChangePassword,
  },
  data: () => ({
      fav: true,
      menu: false,
      dialog: false, // permmet d'ouvrir ou de fermer le popup modal
  }),
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  methods: {
    showProfile() {
      this.menu = false
      router.push({ name: "profile" });
    },

    changePassword() {
      this.menu = false
      this.dialog = true; // open popup modal
    },

    openConfig() {
      this.menu = false
      window.open(`${process.env.VUE_APP_BASE_API}/admin`, '_blank', 'noreferrer');
    }
  }
}
</script>